import { render, staticRenderFns } from "./AddBeneficiary.vue?vue&type=template&id=16c60e8a"
import script from "./AddBeneficiary.vue?vue&type=script&lang=js"
export * from "./AddBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports